import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { timeAgo } from "@/lib/meta";
import { Activity as ActivityIcon } from "lucide-react";

const levelColor = { juice: "#FFC83B", pulp: "#10E396", ai: "#FF9D00" };
const levelLabel = { juice: "LAUNCH", pulp: "BURN", ai: "AGENT" };

export default function ActivityPage() {
  const [feed, setFeed] = useState([]);
  useEffect(() => {
    api.get("/overview").then(({ data }) => setFeed(data.live_feed)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-5 py-8 lg:px-8">
      <div className="mb-6 flex items-center gap-2"><ActivityIcon size={20} className="text-ai" /><h1 className="text-2xl font-bold tracking-tight">Activity</h1></div>
      <p className="mb-6 text-sm text-dust">Every move the agents make, chat-style.</p>

      <div className="rounded-2xl border border-line bg-surface p-5" data-testid="activity-feed">
        <div className="space-y-4 font-mono text-sm">
          {feed.map((e) => (
            <div key={e.id} className="flex items-start gap-3 border-b border-line/40 pb-4 last:border-0">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full animate-soft-pulse" style={{ background: levelColor[e.level] || "#A19A8A" }} />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded px-1.5 py-0.5 text-[10px]" style={{ background: `${levelColor[e.level]}22`, color: levelColor[e.level] }}>{levelLabel[e.level] || "EVENT"}</span>
                  <span className="text-[11px] text-dust">{timeAgo(e.created_at)}</span>
                </div>
                <p className="mt-1.5 text-cream">{e.message}</p>
                {e.launch_id && <Link to={`/app/launches/${e.launch_id}`} className="text-[11px] text-juice hover:underline">open launch</Link>}
              </div>
            </div>
          ))}
          {!feed.length && <p className="text-dust">Nothing yet. Start a launch.</p>}
        </div>
      </div>
    </div>
  );
}
